<template>
	<div class="orderpage">
		<common-header></common-header>
		<div class="text-left flex border-top">
			<div class="left-menu">
				<ul class="side-nav">
					<li class="nav-item">
						<a>个人中心</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage')">个人中心</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>我的钱包</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage/couponList')">优惠券</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>我的关注</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage/collect')">商品收藏</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>订单中心</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/order', 'state=1')">待付款</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order', 'state=2')">待发货</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order', 'state=3')">待评价</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order', 'state=4')">退款售后</el-link></li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="right-container">
				<div class="page-title backcolor padding">收货地址</div>
				<div class="order-container backcolor">
					<el-button type="primary" size="medium" icon="el-icon-location" @click="addAddress('add')">添加收货地址</el-button>
					<template v-if="addressList">
						<el-table :data="addressList" border style="width: 100%">
							<el-table-column prop="name" label="收货人" width="140"></el-table-column>
							<el-table-column prop="address_name" label="所在地区" width="180"></el-table-column>
							<el-table-column prop="area" label="区划代码" width="100"></el-table-column>
							<el-table-column prop="address" label="详细地址"></el-table-column>
							<el-table-column prop="mobile" label="联系方式" width="140"></el-table-column>
							<el-table-column prop="default" label="默认地址" width="100" align="center">
								<template slot-scope="scope">
									<i class="el-icon-check icon-big" v-if="scope.row.default"></i>
									<i class="el-icon-close icon-big" v-else></i>
								</template>
							</el-table-column>
							<el-table-column prop="operate" label="操作" width="180">
								<template slot-scope="scope">
									<el-button type="text" @click="addAddress('change', scope.row)">修改</el-button>
									<el-button type="text" @click="deleteAddress(scope.row)">删除</el-button>
									<el-button v-if="!scope.row.default" type="text" @click="changeAddressDefault(scope.row)">设为默认</el-button>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<el-dialog title="地址管理" :visible.sync="dialogVisible" width="50%">
					<div class="address-info">
						<el-form :model="addressInfo" :rules="rules" ref="addressFrom" label-width="100px" class="demo-addressInfo">
							<el-form-item label="收货人" prop="name"><el-input v-model="addressInfo.name"></el-input></el-form-item>
							<el-form-item label="所在地区" prop="area">
								<el-cascader ref="areaTree" v-model="addressInfo.area" :options="provinceList" :props="{ label: 'label', value: 'value' }" @change="areaChange"></el-cascader>
							</el-form-item>
							<el-form-item label="详细地址" prop="address"><el-input v-model="addressInfo.address"></el-input></el-form-item>
							<el-form-item label="手机号码" prop="mobile"><el-input v-model="addressInfo.mobile"></el-input></el-form-item>
							<el-form-item label="设为默认" prop="default">
								<el-switch v-model="addressInfo.default" active-color="#13ce66" inactive-color="#9e9e9e" :active-value="1" :inactive-value="0"></el-switch>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submitForm('addressFrom')">确 定</el-button>
					</span>
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
import commonHeader from '../../components/common/commonHeader.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import provinceData from '../../components/city-data/province.js';
import cityData from '../../components/city-data/city.js';
import areaData from '../../components/city-data/area.js';
export default {
	name: '',
	components: {
		commonHeader
	},
	data() {
		return {
			addressList: [],
			dialogVisible: false,
			addressInfo: {
				id: '',
				name: '',
				mobile: '',
				shi: '',
				area: '',
				address_name: '',
				address: '',
				full_address: '',
				default: ''
			},
			provinceList: provinceData,
			cityList: cityData,
			areaList: areaData,
			rules: {
				name: [{ required: true, message: '请收入收货人名称', trigger: 'blur' }, { min: 1, max: 8, message: '长度在 1 到 8 个字符', trigger: 'blur' }],
				area: [{ required: true, message: '请选择省市区', trigger: 'blur' }],
				address: [{ required: true, message: '请填写详细收货地址', trigger: 'blur' }, { max: 50, message: '最多可输入50字符', trigger: 'blur' }],
				mobile: [{ required: true, message: '请输入收货人手机号码', trigger: 'blur' }, { min: 1, max: 11, message: '长度在 1 到 11 个字符', trigger: 'blur' }]
			}
		};
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	mounted() {
		this.getAddressList();
		for (let i in this.provinceList) {
			this.provinceList[i].children = this.cityList[i];
			for (let b in this.provinceList[i].children) {
				if (this.areaList[i]) {
					if (this.areaList[i][b]) {
						this.provinceList[i].children[b].children = this.areaList[i][b];
					}
				}
			}
		}
	},
	methods: {
		areaChange(e) {
			this.addressInfo.area = e[e.length - 1];
			this.addressInfo.shi = e[e.length - 2];
			let labels = this.$refs.areaTree.getCheckedNodes()[0].pathLabels;
			this.addressInfo.address_name = labels.join('-');
		},
		expandChange(e) {
			console.log(e);
			let treebnode = this.$refs.areaTree.getCheckedNodes();
			console.log(treebnode);
		},
		getAddressList() {
			this.$request
				.post('/home.user/getAddressList', {
					userid: this.userInfo.id,
					token: this.userInfo.token
				})
				.then(res => {
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.addressList = res.data.addressList;
					}
				})
				.catch(err => {});
		},
		addAddress(type, scope = '') {
			if (type == 'add') {
				this.addressInfo = {
					id: '',
					name: '',
					mobile: '',
					shi: '',
					area: '',
					address_name: '',
					address: '',
					full_address: '',
					default: ''
				};
			}else{
				this.addressInfo = JSON.parse(JSON.stringify(scope));
				this.addressInfo.area = String(this.addressInfo.area);
				console.log(this.addressInfo);
			}
			this.dialogVisible = true;
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.addAddressSubmit();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		addAddressSubmit(){
			this.$emit('showLoading',true);
			let addressData = this.addressInfo;
			addressData.userid = this.userInfo.id,
			addressData.token = this.userInfo.token,
			this.$request.post('/home.user/addAddress',addressData)
			.then(res=>{
				this.$emit('showLoading',false);
				if (res.data.status == 0) {
					this.$message.error(res.data.msg);
					if (res.data.admin_err == 'userinfo_error') {
						this.exit().then(res => {
							console.log(res);
							if (res.actionStatus == 1) {
								this.$router.push('/login');
							}
						});
					}
				} else {
					this.$message.success(res.data.msg);
					this.getAddressList();
				}
				this.dialogVisible = false;
			})
			.catch(err=>{
				this.$emit('showLoading',false);
				this.dialogVisible = false;
			})
		},
		changeAddressDefault(scope){
			this.$confirm('是否将当前地址设为默认收货地址？')
			.then(_=>{
				this.addressInfo = JSON.parse(JSON.stringify(scope));
				this.addressInfo.default = 1;
				this.addAddressSubmit();
			})
			.catch(_=>{
				
			})
		},
		deleteAddress(scope){
			this.$confirm('是否删除当前选中地址？')
			.then(_=>{
				this.$request.post('/home.user/deleteAddress',{
					address_id:scope.id,
					userid:this.userInfo.id,
					token:this.userInfo.token
				})
				.then(res=>{
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.getAddressList();
					}
				})
				.catch(err=>{
					
				})
			})
			.catch(_=>{
				
			})
		}
	}
};
</script>
<style lang="scss">
.el-main {
	.orderpage {
		background-color: #f0f3ef !important;
	}
	.left-menu {
		width: 170px;
		// flex-shrink:0;
		background-color: #fff;
		.side-nav {
			> .nav-item {
				padding: 15px 20px;
				border-bottom: 1px solid #f3f3f3;
				a {
					font-size: 15px;
					font-weight: bold;
					text-decoration: none;
					line-height: 40px;
				}
				.nav-item {
					a {
						font-size: 14px;
						line-height: 30px;
						&:hover {
							cursor: pointer;
						}
					}
				}
			}
		}
	}
	.right-container {
		flex: 1;
		padding: 20px 0 0 20px;
		background-color: #f0f3ef !important;
		.backcolor {
			background-color: #fff;
		}
		.padding {
			padding: 0 15px;
		}
		.page-title {
			line-height: 40px;
		}
		.order-container {
			margin-top: 15px;
			// margin-left: 15px;
			.menu-btn {
				button {
					color: dimgray;
					padding: 0 10px;
					line-height: 35px;
					&:hover {
						color: $base-color;
					}
					&.active {
						color: $base-color;
						border-bottom: 2px solid $base-color;
					}
				}
			}
			.order-item {
				margin-top: 10px;
				border: 1px solid #dddddd;
				.th {
					background-color: #e1e1e1;
					font-size: 14px;
					line-height: 35px;
					span + span {
						margin-left: 15px;
					}
				}
				.item-border {
					> div {
						border-right: 1px solid #dddddd;
						padding-top: 15px;
						text-align: center;
						&:first-child {
							padding: 0 15px;
							text-align: left;
						}
						&:first-child {
							padding-top: 0;
						}
						&:last-child {
							border-right: none;
						}
					}
				}
				.goods-info {
					flex: 1;
					.goods-item {
						border-bottom: 1px solid #dddddd;
						&:last-child {
							border: none;
						}
						padding: 15px 0;
						.smpic {
							width: 60px;
							height: 60px;
						}
						.goods-title {
							flex: 1;
							padding-left: 15px;
						}
						.param-num {
							padding: 0 15px;
							text-align: center;
							color: gray;
							font-size: 14px;
							line-height: 30px;
							.num {
								&::before {
									content: 'x';
									margin-right: 3px;
								}
							}
						}
					}
				}

				.user-address {
					width: 85px;
					line-height: 30px;
					&:hover {
						cursor: pointer;
					}
				}
				.order-pay {
					width: 90px;
					line-height: 30px;
					text-align: center;
					.pay {
						border-bottom: 1px solid #ccc;
						&::before {
							content: '￥';
						}
					}
				}
				.order-status {
					width: 82px;
				}
				.operate {
					width: 120px;
					text-align: center;
					.chaoshi_tip {
						font-size: 13px;
						color: #cccccc;
					}
					.block {
						display: block;
						+ .block {
							margin-top: 10px;
						}
					}
				}
			}
		}
	}
	.border-top {
		border-top: 1px solid #f3f3f3;
	}
	.icon-big {
		font-size: 19px;
		&.el-icon-check {
			color: green;
		}
		&.el-icon-close {
			color: lightgray;
		}
	}
}
</style>
